import ChildParentRelation from '../dto/ChildParentRelation';
import Error from '../model/Error';
import axios from 'axios';

export default class OccupantRepository {
    static findAll(childId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/children/${childId}/parent-relations`)
                .then(response => resolve(response.data.data.map(data => ChildParentRelation.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
